/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import { Fragment, useCallback, useContext, useState } from "react";
import { DateTimeEdit } from "../_common/date-time";
import Config from "data/config";
import dayjs from "dayjs";
import { EntityContext } from "../../context";
// import debounce from "lodash.debounce";
// import { TextField } from "@mui/material";
// import { ListItemContext } from "cms/fields/field-lists/field-list-context";
// import { useTranslation } from "react-i18next";
// import { useSelectFieldSchema } from "cms/fields/hooks/use-select-field-schema";

const STORAGE_FORMAT = Config.dates.internalFormats.date;

const DateTimeEntityAttributeEditor = (props) => {
    
    // const { t } = useTranslation();
    const type = props.type;
    const name = props.name;
    const value = props.value;
    // const ctx = useContext(ListItemContext);
    // const { type, name, index, value, settings, updateListItem, disabled = false } = ctx;
    // const initialState = {
    //     value: value ? value : "",
    // };
    // const [itemLocalState, setItemLocalState] = useState(initialState);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    // const update = useCallback(
    //     debounce((updateState, index) => {
    //         updateListItem(updateState, index);
    //     }, 1200),
    //     [updateListItem]
    // );
    
    const parseFormat = Config.dates.internalFormats.date;
    // const displayFormat = Config.dates.display.date;
    // const editDate = dayjs(value, parseFormat).format(displayFormat);
    
    const [datetime, setDatetime] = useState(value);
    
    const entityContext = useContext(EntityContext);
    // const schema = entityContext?.schema;
    // const entity = entityContext?.entity;
    // const attr = entityContext?.attr;
    const updateAttribute = entityContext?.updateAttribute;
    
    const onChangeDateTime = (selectedDate) => {
        const selected = selectedDate
            ? dayjs(selectedDate).format(parseFormat)
            : "";
        setDatetime(selected);
        updateAttribute(name, selected);
    };
    
    return (
        <Fragment>
            <div className="entity-attribute-editor-label">
                {name}
            </div>
            <div className="entity-attribute-editor-panel">
                <DateTimeEdit
                    name={name}
                    type={type}
                    value={datetime}
                    onChangeDateTime={onChangeDateTime}
                />
            </div>
        </Fragment>
    );
};

export { DateTimeEntityAttributeEditor };
